<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import MultiselectDropdown from '../../../../../shared/components/ui/MultiselectDropdown.vue';

const props = defineProps({
  subServices: {
    type: Array,
    default: () => [],
  },
  selectedSubServiceId: {
    type: [Number, String],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:selectedSubServiceId', 'change']);
const { t } = useI18n();

const selectedSubService = computed(() => {
  return (
    props.subServices.find(
      subService => subService.id === props.selectedSubServiceId
    ) || {}
  );
});

const handleSubServiceChange = newSubService => {
  if (props.disabled) return;

  if (newSubService.id === props.selectedSubServiceId) {
    emit('update:selectedSubServiceId', null);
    emit('change', null);
    return;
  }

  emit('update:selectedSubServiceId', newSubService.id);
  emit('change', newSubService);
};
</script>

<template>
  <div>
    <div @click.prevent>
      <MultiselectDropdown
        :options="subServices"
        :selected-item="selectedSubService"
        :multiselector-title="t('TICKETS.SUB_SERVICE.SELECT_TITLE')"
        :multiselector-placeholder="t('TICKETS.SUB_SERVICE.SELECT_PLACEHOLDER')"
        :input-placeholder="t('TICKETS.SUB_SERVICE.SEARCH_PLACEHOLDER')"
        :no-search-result="t('TICKETS.SUB_SERVICE.NO_RESULTS')"
        :has-thumbnail="false"
        :disabled="disabled"
        @select="handleSubServiceChange"
      />
    </div>
  </div>
</template>


